// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__2jmnR","title":"ClientInsurance_title__TZ-4c","itemText":"ClientInsurance_itemText__2COwQ"};